import { db } from "./firebase";
import { doc, getDoc } from "firebase/firestore";


function parseMateria(rawValue) {
  const parts = rawValue.split("@@");
  return {
    title: parts[0] || "",
    bgColor: parts[1] || "#FFFFFF",
    fontColor: parts[2] || "#000000",
    icon: parts[3]?.replace("@", "") || "default",
  };
}

export function contarTemas(contenido) {
  if (!contenido) return 0;
  return contenido
    .split("-")                // separar por guiones
    .filter((item) => item.length <= 4)
    .length;
}

export async function getComplements() {
  const docRef = doc(db, "Complements", "APP ForiApps");
  const docSnap = await getDoc(docRef);

  if (docSnap.exists()) {
    const data = docSnap.data();

    // 👇 aquí accedemos al campo "00 Codigos"
    const codigos = data["00 Codigos"];

    const materias = Object.keys(codigos).map((key) => {
      const parsed = parseMateria(codigos[key]);
      return {
        id: key,
        ...parsed,
      };
    });

    return materias;
  } else {
    console.warn("No existe el documento APP ForiApps en Complements");
    return [];
  }
}

export async function getComplementsCached() {
  const cacheKey = "complements";
  const cache = sessionStorage.getItem(cacheKey);

  if (cache) {
    //console.log("Se leyeron Complements de caché");
    return JSON.parse(cache);
  }

  const docRef = doc(db, "Complements", "APP ForiApps");
  const docSnap = await getDoc(docRef);

  if (docSnap.exists()) {
    const data = docSnap.data();
    const codigos = data["00 Codigos"];

    const materias = Object.keys(codigos).map((key) => {
      const parsed = parseMateria(codigos[key]);
      return { id: key, ...parsed };
    });

    sessionStorage.setItem(cacheKey, JSON.stringify(materias));
    //console.log("Se leyeron Complements de Firestore");
    return materias;
  }

  return [];
}

export function updateComplementsCache(nuevosDatos) {
  sessionStorage.setItem("complements", JSON.stringify(nuevosDatos));
}